import { AxiosResponse } from 'axios';

import { ApiService } from '../api/api.service';

export interface EpopService {
  getEpopsForRestaurant(restaurantId: number): Promise<any>;
}

export class AppEpopService extends ApiService implements EpopService {
  getEpopsForRestaurant(restaurantId: number) {
    return this.httpClient
      .get(`/epops/v2/${restaurantId}?channel=Web`)
      .then((res: AxiosResponse<any>) => res.data)
      .catch(e => this.logAndThrowApiError('getEPOPsforRestaurant', e));
  }
}
